import styled from 'styled-components';
import UILogo from 'UIComponents/image/UILogo';
import UIFlex from 'UIComponents/layout/UIFlex';
import H3 from 'UIComponents/elements/headings/H3';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_LARGE } from 'HubStyleTokens/sizes';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import { addUrlParams } from '../../../utils/RoutingUtils';
import { useCallback } from 'react';
import { getBrochureRoot } from '../achievementQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const breakpoint = GRID_BREAKPOINT_MEDIUM;
const UIFlexResponsive = styled(UIFlex).withConfig({
  displayName: "CertificateHeader__UIFlexResponsive",
  componentId: "dglcct-0"
})(["flex-direction:column;align-items:start;width:auto;@media (min-width:", "){flex-direction:row;align-items:center;}"], breakpoint);
const CertHeading = styled(H3).withConfig({
  displayName: "CertificateHeader__CertHeading",
  componentId: "dglcct-1"
})(["font-weight:lighter;@media (min-width:", "){margin:0 0 -4px 20px;}@media (max-width:", "){font-size:18px;margin:6px 0 0 0;}.item{display:inline-block;}.my-cert{margin-left:0.5em;padding-left:0.5em;border-left:1px solid currentColor;}"], breakpoint, breakpoint);
const buildUrl = (brochureRoot, path, cta) => addUrlParams(`${brochureRoot}${path}`, {
  'hubs_content-cta': cta
});
const NavLinks = ({
  links = [],
  trackEvent,
  language
}) => {
  const brochureRoot = getBrochureRoot(language);
  const trackClick = useCallback(({
    currentTarget
  }) => trackEvent({
    action: 'click-header-nav-button',
    href: currentTarget.href,
    isExternalLink: true,
    isResponsive: JSON.parse(currentTarget.dataset.isResponsive)
  }), [trackEvent]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: links.map(([label, cta, path]) => /*#__PURE__*/_jsx(UIButton, {
      className: "nav-link",
      "data-is-responsive": false,
      external: true,
      href: buildUrl(brochureRoot, path, cta),
      iconProps: {
        className: 'hidden'
      },
      onClick: trackClick,
      target: "_blank",
      use: "transparent",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.certification.heading.nav.${label}`
      })
    }, `${label}${path}`))
  });
};
const NavMenu = styled(({
  className,
  inModal,
  links,
  trackEvent,
  language
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx("div", {
      className: "full-links",
      children: /*#__PURE__*/_jsx(NavLinks, {
        language: language,
        links: links,
        trackEvent: trackEvent
      })
    }), !inModal && /*#__PURE__*/_jsx("div", {
      className: "nav-dropdown",
      children: /*#__PURE__*/_jsx(UIDropdown, {
        buttonClassName: "p-y-3 p-x-2",
        buttonText: /*#__PURE__*/_jsx(UIIcon, {
          color: OBSIDIAN,
          name: "listView",
          size: "xs"
        }),
        buttonUse: "unstyled",
        caretRenderer: null,
        placement: "bottom left",
        popoverProps: {
          arrowSize: 'small'
        },
        children: /*#__PURE__*/_jsx(UIList, {
          children: /*#__PURE__*/_jsx(NavLinks, {
            language: language,
            links: links,
            trackEvent: trackEvent
          })
        })
      })
    })]
  });
}).withConfig({
  displayName: "CertificateHeader__NavMenu",
  componentId: "dglcct-2"
})(["align-self:center;margin-top:6px;.nav-link{padding:0;color:", ";border:none;&:hover{color:", ";text-decoration:none;}}@media (max-width:", "){.full-links{display:none;}}@media (min-width:", "){.nav-dropdown{display:none;}}"], OBSIDIAN, OBSIDIAN, GRID_BREAKPOINT_LARGE, GRID_BREAKPOINT_LARGE);
NavMenu.defaultProps = {
  links: [['courses', 'achievement-cta-courses', '/courses'], ['certifications', 'achievement-cta-certifications', '/certification-overview'], ['aboutAcademy', 'achievement-cta-about-academy', '/what-is-hubspot-academy']]
};
const CertificateHeader = ({
  inModal,
  trackEvent,
  language
}) => /*#__PURE__*/_jsxs("header", {
  className: "p-y-4",
  style: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between'
  },
  children: [/*#__PURE__*/_jsxs(UIFlexResponsive, {
    justify: "start",
    children: [/*#__PURE__*/_jsx(UILogo, {
      height: 30,
      name: "hubspot-wordmark"
    }), /*#__PURE__*/_jsxs(CertHeading, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "item",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.heading.academy"
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "item my-cert",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.heading.achievements"
        })
      })]
    })]
  }), /*#__PURE__*/_jsx(NavMenu, {
    inModal: inModal,
    language: language,
    trackEvent: trackEvent
  })]
});
export default CertificateHeader;